module.exports = __webpack_public_path__ + "static/media/K.19dc8368.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/galaxyRewards/K.png
// module id = 2064
// module chunks = 0